import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import { EventEmitter } from 'events';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { ITEM_TYPE } from '../../customers/constants';
import Date from '../../../common/date';
import loyaltyReward from '../../../../../images/loyalty-reward-icon.svg';
import { APPOINTMENT_STATUS } from '../constants';

class AppointmentsList extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    appointments: PropTypes.arrayOf(PropTypes.object).isRequired,
    futureItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    pastItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    fetchAppointment: PropTypes.func,
    addNotification: PropTypes.func,
    showPastItems: PropTypes.func.isRequired,
    showFutureItems: PropTypes.func.isRequired,
    openedTab: PropTypes.oneOf(['futureItems', 'pastItems']).isRequired,
  }

  static defaultProps = {
    fetchAppointment: null,
    addNotification: null,
    barberId: null,
  }

  static getAppointmentPeriod(appointment) {
    if (appointment.start) {
      return (
        <span>
          <Date format="hh:mma">{appointment.start}</Date>
          {' '}-{' '}
          <Date format="hh:mma, MMM DD, YYYY">{appointment.end}</Date>
        </span>
      );
    }
    return <Date format="hh:mma, MMM DD, YYYY">{appointment.compareDate}</Date>;
  }

  getCaption(appointment) {
    if (this.props.type === 'customer') {
      let caption = ` by ${appointment.barberFullName}`;
      if (this.props.activeType === 'brand' && appointment.shopName) {
        caption = `${caption} @ ${appointment.shopName}`;
      }
      return caption;
    }
    return ` for ${appointment.customerFullName}`;
  }

  getAppointmentCount() {
    if (isEmpty(this.props.appointments)) return '';
    return `(${this.props[this.props.openedTab].length})`;
  }

  openAppointment = item => async () => {
    if (item.barberDeleted) {
      if (this.props.addNotification) {
        this.props.addNotification({
          title: 'Cannot proceed',
          level: 'warning',
          message: 'Barber for this appointment is deleted.',
        });
      }
      return false;
    }

    const getAppointment = () => {
      if (typeof this.props.fetchAppointment !== 'function') return item;
      return this.props.fetchAppointment(item.id);
    };
    EventEmitter.prototype.emit('appointment-clicked', await getAppointment());
  }

  renderAppointment = appointment => (
    <a
      key={appointment.id}
      className={classnames('c-appointment-card', {
        'c-appointment-card--striped': appointment.status === APPOINTMENT_STATUS.canceled,
        'no-pointer-events': appointment.type === ITEM_TYPE.sale,
      })}
      onClick={this.openAppointment(appointment)}
      style={{ borderLeftColor: appointment.barberColor }}
    >
      <span>
        {appointment.description}&nbsp;
      </span>
      <span>
        {this.getCaption(appointment)}&nbsp;
      </span>
      <small className="u-ml-auto">
        {AppointmentsList.getAppointmentPeriod(appointment)}
      </small>
      <img
        src={loyaltyReward}
        alt="Loyalty reward"
        display-if={appointment.isRewardPromo}
      />
    </a>
  )

  renderAppointments() {
    if (isEmpty(this.props[this.props.openedTab])) return 'No appointments.';
    return map(this.props[this.props.openedTab], this.renderAppointment);
  }

  render() {
    return (
      <div className="c-wrapper">
        <div className="u-max-width-710 u-margin-auto u-ph- large-and-up-ph0 u-bg-white">
          <ul className="c-nav-tabs list-bare u-mt- medium-and-up-mt">
            <li>
              <button
                type="button"
                onClick={this.props.showFutureItems}
                className={classnames('c-nav-tab', { 'is-active': this.props.openedTab === 'futureItems' })}
              >
                Future Appointments ({this.props.futureItems.length})
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={this.props.showPastItems}
                className={classnames('c-nav-tab', { 'is-active': this.props.openedTab === 'pastItems' })}
              >
                {
                  this.props.type === 'customer'
                    ? `Past Appointments and Sales (${this.props.pastItems.length})`
                    : `Past Appointments (${this.props.pastItems.length})`
                }
              </button>
            </li>
          </ul>
          <div className="u-height-510 u-scrollable u-ph-- u-mt">
            { this.renderAppointments() }
          </div>
        </div>
      </div>
    );
  }
}

export default AppointmentsList;
